import { Paper, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { Code } from '../../../components/types/templates/types';
import parse from "html-react-parser"
import { Item } from '../../../components/types/generator/types';

export const GalletyPreview: React.FC<{ code: Code, items?: Item[] }> = ({ code, items }) => {
  const { css } = code;
  const [codeFinal, setCodeFinal] = useState('');

  const mockItem: Item = {
    id: 0,
    name: 'name_1',
    adress:
      'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png',
  };

  const mockItems: Item[] = Array(10).fill(mockItem);

  useEffect(() => {
    setCodeFinal(generateHTML(items ?? mockItems, code) + '\n' + css);
  }, [code, items, mockItems, css]);

  return (
    <Paper sx={{
      mt: 2, mb: 2, padding: '10px',
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    }}>
      <Typography
        component="h1"
        variant="h6"
        color="inherit"
        noWrap
        sx={{
          flexGrow: 1,
          marginBottom: '10px',
        }}
      >
        Podgląd na żywo
      </Typography>
      {parse(codeFinal)}
    </Paper>
  );
};

export const generateHTML = (items: Item[], code: Code) => {
  let newItems = '';
  items.forEach((item) => {
    newItems +=
      '\n' +
      code.item
        .replaceAll('$adress', item.adress)
        .replaceAll('$name', item.name);
  });
  return code.gallery.replace('$items', newItems);
};
